<template>
  <li class="add-new-wrapper" @click="addToken">
    <div class="add-new badge-js">+</div>
    <h3 class="token-title">Voeg partij toe</h3>
  </li>
</template>

<script>
  import EventBus from "../eventBus";

  export default {
    name: "AddToken",

    props: {
      parties: {
        type: Array,
        default: () => [],
      },
      totalParties: {
        type: Number,
        default: () => 0,
      },
    },

    methods: {
      // add custom token to list
      addToken() {
        var name = prompt("Afkorting van Partij, bijvoorbeeld CDA", "");
        if (name) {
          EventBus.$emit("addToken");

          // add data of token to the start of the dataset
          this.parties.unshift({
            id: this.totalParties,
            name: name,
            color: this.getRandomColor(),
            removable: true,
          });
        }
      },

      // generate random color
      getRandomColor() {
        var length = 6;
        var chars = "0123456789ABCDEF";
        var hex = "#";
        while (length--) hex += chars[(Math.random() * 16) | 0];
        return hex;
      },
    },
  };
</script>

<style scoped lang="scss">
  .add-new-wrapper {
    width: 100%;
    display: inline-block;
    position: sticky;
    top: 0;
    z-index: 1000;
    background: $color-grey-light;
    padding: 20px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    user-select: none;
    box-sizing: border-box;
  }

  .add-new {
    width: 3vw;
    height: 3vw;
    border-radius: 100%;
    margin: 0 auto;
    overflow: hidden;
    font-weight: 100;
    background-color: rgba(0, 0, 0, 0.15);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3vw;
    transition: background-color 0.5s;
    cursor: pointer;

    &:hover {
      background-color: $cerulean;
    }

    &:active {
      background-color: rgba(0, 0, 0, 0.2);
      transform: scale(0.95);
    }
  }

  .token-title {
    font-size: 10px;
    text-align: center;
    padding-top: 15px;
    font-weight: $font-regular;
    position: relative;
  }
</style>
